import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MapDirectionsService } from '@angular/google-maps';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  // check to see if google maps API is loaded successfully
  apiLoaded: Observable<boolean>;

  // default zoom setting
  zoom = 4;

  directionsResults$!: Observable<google.maps.DirectionsResult | undefined>;
  origin_address: string = '';
  destination_address: string = '';
  distanceInKm: string = '';
  distanceInMiles: string = '';
  duration: string = ''

  constructor(mapDirectionsService: MapDirectionsService, httpClient: HttpClient, private route: ActivatedRoute) {
    this.apiLoaded = httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=AIzaSyAzSR0J6xgrW-6lW9mU2ZcBzDi8Ufy664U', 'callback')
      .pipe(
        map(() => {
          console.log('Google Maps API loaded successfully')
          console.log(this.origin_address)

          // create request for the directions service
          const request: google.maps.DirectionsRequest = {
            destination: this.destination_address,
            origin: this.origin_address,
            travelMode: google.maps.TravelMode.DRIVING,
            avoidTolls: true
          };

          // use directions service route to retrieve response containing direction results
          this.directionsResults$ = mapDirectionsService.route(request).pipe(map(response => {
            // directions result from API 
            const result = response.result

            // distance of trip in meters
            const distanceValue = result?.routes[0]?.legs[0]?.distance?.value

            // set parameters of trip distance and transit time from response
            this.duration = result?.routes[0]?.legs[0]?.duration?.text || ''
            this.distanceInKm = distanceValue ? (distanceValue / 1000).toFixed(1) + ' km' : '0'
            this.distanceInMiles = distanceValue ? (distanceValue / 1609.344).toFixed(1) + ' mi' : '0'

            // return the response to the directionResults variable
            return result
          }));

          // true if api loaded successfully
          return true
        }),
        // check if error loading google maps API
        catchError((err) => {
          console.log(err)
          console.log('Error loading Google Maps API')
          return of(false)
        }),
      );
  }

  // on init set origin and destination address from URL paramters: map/address/address2
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.origin_address = params.get('address') || '';
      this.destination_address = params.get('address2') || '';
    });
  }
}